import { z } from 'zod';
/** What a scenario is evaluated against: one fires per encounter, per order, or per patient. */
export var ScenarioEntity;
(function (ScenarioEntity) {
    ScenarioEntity["Encounter"] = "ENCOUNTER";
    ScenarioEntity["Order"] = "ORDER";
    ScenarioEntity["Patient"] = "PATIENT";
})(ScenarioEntity || (ScenarioEntity = {}));
export const ScenarioEntitySchema = z.enum(ScenarioEntity);
//# sourceMappingURL=entity.js.map